import { useShallow } from "zustand/react/shallow";
import type { SimulationStats } from "@/features/simulation/public";
import { useSimulationStore } from "@/features/simulation/store";

/**
 * StatsPanel が必要とする state のみを抽出するセレクターフック。
 *
 * params 変更などでは再レンダしないように useShallow で 3 フィールドだけを購読する。
 */
export interface SimulationStatsView {
  stats: SimulationStats;
  running: boolean;
  conveyorStopped: boolean;
}

export function useSimulationStats(): SimulationStatsView {
  return useSimulationStore(
    useShallow(
      (s): SimulationStatsView => ({
        stats: s.stats,
        running: s.running,
        conveyorStopped: s.conveyorStopped,
      }),
    ),
  );
}
